import { BallIcon } from "./Logo";

const ITEMS = [
  "THE YOUTH PITCH",
  "PLAY VS WATCH",
  "MORBI SURVEY",
  "THE POINTS TABLE",
  "HONEST ANSWERS ONLY",
  "BY A LOCAL TEEN",
];

const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative w-[110%] -ml-[5%] -my-2 rotate-[-1.2deg] bg-pitch dark:bg-card text-cream border-y-2 border-flame/70 overflow-hidden py-4 shadow-lg shadow-pitch/20"
    aria-label="Site highlights"
  >
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
          {ITEMS.map((t, i) => (
            <span key={i} className="flex items-center">
              <span className="font-display font-bold uppercase tracking-[0.14em] text-base sm:text-lg px-6 whitespace-nowrap">
                {t}
              </span>
              <BallIcon className="h-4 w-4 text-turf shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default EditorialMarquee;
